import { NgModule } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { MomentDateAdapter } from '@angular/material-moment-adapter';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';

import { NgReduxModule, NgRedux } from '@angular-redux/store';
import { RedirectingModule } from '@tango/app/redirecting';
import { UserIdleModule } from 'angular-user-idle';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { AppComponent } from './app.component';
import { AppVersionComponent } from '@tango/app/app-version';

import { CoreModule as RootCoreModule } from '@tango/app/core';
import { BANK_APP_CONFIG } from './app.config';
import { CoreModule as AppCoreModule } from './core/core.module';
import { BankLoginModule } from './login';
import { LockedPageModule } from './locked-page';
import { MaintenanceStatusModule } from '@tango/app/maintenance-status';
import { AppRoutingModule } from './app-routing.module';

import { AppState } from '@tango/app/interfaces';
import { store } from '@tango/app/store';
import { APP_CONFIG } from '@tango/app/app.config';
import { CONFIG } from './config';

const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'DD.MM.YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

const appProviders: any[] = [
  { provide: APP_CONFIG, useValue: CONFIG },
  { provide: BANK_APP_CONFIG, useValue: CONFIG },
  Title,
  { provide: MAT_DATE_LOCALE, useValue: 'uk' },
  {
    provide: DateAdapter,
    useClass: MomentDateAdapter,
    deps: [MAT_DATE_LOCALE],
  },
  { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
];

export const HttpLoaderFactory = (http: HttpClient) =>
  new TranslateHttpLoader(http);

@NgModule({
  imports: [
    BrowserModule,
    HttpClientModule,
    BrowserAnimationsModule,
    NgReduxModule,
    RootCoreModule,
    AppCoreModule,
    BankLoginModule,
    RedirectingModule,
    LockedPageModule,
    MaintenanceStatusModule,
    UserIdleModule.forRoot({ idle: 450, timeout: 450, ping: 300 }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    AppRoutingModule,
  ],
  declarations: [AppComponent, AppVersionComponent],
  providers: appProviders,
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(ngRedux: NgRedux<AppState>) {
    ngRedux.provideStore(store);
  }
}
